import { WoopQuickSearch } from './WoopQuickSearch/WoopQuickSearch';

import { AccessFilter } from '../../../_components/AccessFilter';
import { StatusFilter } from '../../../_components/StatusFilter';
import { VerticalScalingPolicyFilter } from '../../../_components/VerticalScalingPolicyFilter';
import { NamespacesFilter } from '../../../_workloads-list/components/NamespacesFilter';
import { ClearAllButton, Search } from '@cast/shared-search-ui';
import { useIsAccessContextOwner } from '../../../_hooks/permissions/useIsAccessContextOwner';

import { Box, Stack } from '@cast/design-system';

export const Filters = () => {
  const isOwner = useIsAccessContextOwner();
  const showAccessFilter = !isOwner;

  return (
    <Stack gap={8} data-testid="filters">
      <Box flex={1}>
        <Search size="small" />
      </Box>

      <Box
        display="grid"
        gridTemplateColumns={
          showAccessFilter ? '1fr 1fr 1fr 1fr auto' : '1fr 1fr 1fr auto'
        }
        columnGap={8}
      >
        <NamespacesFilter />
        <VerticalScalingPolicyFilter />
        <StatusFilter />
        {showAccessFilter && <AccessFilter />}
        <ClearAllButton size="sm" />
      </Box>

      <WoopQuickSearch />
    </Stack>
  );
};
